import { ISuggestedCartProduct } from '@/store/modules/basket/interfaces/suggestedCart'

const STORAGE_KEY = 'suggestedCartAmounts'

export interface CartAmount {
  units: number
  layers: number
  pallets: number
  checked?: boolean
}

export function getCartHash (items: ISuggestedCartProduct[]): string {
  const base = items
    .map(i => ({
      sku: i.sku,
      price: i.your_price_w_vat,
      units: i.total_units,
      layers: i.number_of_layers,
      pallets: i.number_of_pallets
    }))
    .sort((a, b) => a.sku.localeCompare(b.sku))

  return btoa(JSON.stringify(base))
}

export function getAmounts (
  shipToId: string,
  transportType: 'standard' | 'truck',
  hash: string
): Record<string, CartAmount> | null {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  const data = JSON.parse(raw)
  const entry = data?.[shipToId]?.[transportType]
  return entry?.hash === hash ? entry.amounts : null
}

export function saveAmountsDual (
  shipToId: string,
  hash: string,
  amounts: Record<string, CartAmount>
) {
  const raw = localStorage.getItem(STORAGE_KEY)
  const data = raw ? JSON.parse(raw) : {}

  data[shipToId] ??= {}

  data[shipToId].standard = { hash, amounts }

  // save truck
  const zeroed: Record<string, CartAmount> = {}
  for (const sku in amounts) {
    zeroed[sku] = { units: 0, layers: 0, pallets: 0, checked: false }
  }
  data[shipToId].truck = { hash, amounts: zeroed }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function saveAmounts (
  shipToId: string,
  transportType: 'standard' | 'truck',
  hash: string,
  amounts: Record<string, CartAmount>
) {
  const raw = localStorage.getItem(STORAGE_KEY)
  const data = raw ? JSON.parse(raw) : {}

  data[shipToId] ??= {}

  data[shipToId][transportType] = { hash, amounts }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}
